/* ABTEST 30 — offer-PDP staffelblok (blocks/abtest-30-offer.liquid).
 *
 * Tier-wissel is puur client-side en raakt alleen server-side gerenderde
 * markup: de radio bepaalt welke prijsregel/chip (data-abtest30-tier, uit
 * snippets/abtest-30-offer-price.liquid) zichtbaar is, zet de quantity op
 * het formulier en de knoptekst (data-btn-label, server-side geformatteerd).
 * Er wordt hier nooit geld geformatteerd of gerekend.
 *
 * ?tier=1|2|3 preselecteert het tier met die quantity; onbekende of
 * ontbrekende waarden vallen terug op de server-side default (hoogste tier).
 *
 * VERWIJDERPLAN — zie experiments/30-offer-pdp/result.md.
 */
class Abtest30Offer extends HTMLElement {
  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('input[name^="abtest30-tier-"]'));
    this.qtyInput = this.querySelector('[data-abtest30-quantity]');
    this.btn = this.querySelector('[data-abtest30-btn]');
    this.form = this.querySelector('form');
    if (!this.radios.length || !this.qtyInput) return;

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.sync());
    });

    // ?tier= preselect: waarde = quantity van het tier (1/2/3).
    const tier = new URLSearchParams(window.location.search).get('tier');
    if (tier) {
      const match = this.radios.find((r) => r.dataset.qty === tier);
      if (match) match.checked = true;
    }

    // Dubbelklik = één add: knop op disabled zodra de submit loopt. De
    // disable moet ná de submit-afhandeling (een disabled knop verstuurt
    // in sommige browsers het formulier niet meer).
    if (this.form && this.btn) {
      this.form.addEventListener('submit', () => {
        requestAnimationFrame(() => {
          this.btn.disabled = true;
        });
      });
    }

    this.sync();
  }

  sync() {
    const checked = this.radios.find((r) => r.checked);
    if (!checked) return;
    const qty = checked.dataset.qty;
    this.qtyInput.value = qty;
    if (this.btn && checked.dataset.btnLabel) {
      this.btn.textContent = checked.dataset.btnLabel;
    }
    document.querySelectorAll('[data-abtest30-tier]').forEach((el) => {
      el.hidden = el.getAttribute('data-abtest30-tier') !== qty;
    });
  }
}

if (!customElements.get('abtest-30-offer')) {
  customElements.define('abtest-30-offer', Abtest30Offer);
}
